import { render, staticRenderFns } from "./GeneraDictamen.vue?vue&type=template&id=e36ef1c4"
import script from "./GeneraDictamen.vue?vue&type=script&lang=js"
export * from "./GeneraDictamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports